import { AnalyticsProvider } from "core/analytics/AnalyticsProvider";
import { AuthenticationProvider } from "core/auth/AuthenticationProvider";
import { config } from "core/config";
import { ReactQueryProvider } from "core/ReactQueryProvider";
import { PublicRouter } from "layout/PublicRouter";

import {
  BpThemeProvider,
  customIcons,
  initializeIcons,
  registerIcons
} from "@bps/fluent-ui";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "./common/reset.css";
import { CoreDataFetcher } from "./core/CoreDataFetcher";
import { BlocksProvider } from "./core/providers/BlocksProvider";

// Fluent UI and NP custom icons ref: https://devinfrasa.z8.web.core.windows.net/?path=/story/foundations-icons--icons-stories
initializeIcons();

registerIcons({
  fontFace: {
    fontFamily: "BP_custom_icons"
  },
  icons: customIcons
});

export const App = () => {
  return (
    <BpThemeProvider>
      <AuthenticationProvider>
        <ReactQueryProvider>
          <CoreDataFetcher>
            <AnalyticsProvider>
              <BlocksProvider>
                <PublicRouter />
              </BlocksProvider>
              {config.environment && import.meta.env.MODE === "development" && (
                <ReactQueryDevtools initialIsOpen={false} />
              )}
            </AnalyticsProvider>
          </CoreDataFetcher>
        </ReactQueryProvider>
      </AuthenticationProvider>
    </BpThemeProvider>
  );
};
